import { useQuery } from '@tanstack/react-query';

import { fetchContentQuestions } from '~/services/content-questions/content-questions-service';

export const QUERY_KEY_CONTENT_QUESTIONS = 'QUERY_KEY_CONTENT_QUESTIONS';

interface UseContentQuestionsProps {
  queryCounter: number;
  askedQuestionsLength: number;
  enabled: boolean;
}

export const useContentQuestions = ({
  queryCounter,
  askedQuestionsLength,
  enabled,
}: UseContentQuestionsProps) =>
  useQuery({
    queryKey: [QUERY_KEY_CONTENT_QUESTIONS, queryCounter, askedQuestionsLength],
    queryFn: ({ signal }) => fetchContentQuestions(signal),
    enabled,
  });
